import { memo } from "react";

import { AppShell, Container } from "@mantine/core";
import { Outlet } from "react-router-dom";

import { AppFooter } from "~/features/layout/Footer";

import { AppHeader } from "../layout/Header";

const DashboardLayout = () => {
  return (
    <AppShell header={<AppHeader />} footer={<AppFooter />}>
      <Container size="xl" pt={24}>
        <Outlet />
      </Container>
    </AppShell>
  );
};

export default memo(DashboardLayout);
